<template>
  <div>
    <Nav />
    <div class="main">
      <header class="header">
        <div class="header-img">
          <div class="header-content">
            <div class="header-content-text">
              <h1 class="header-title">Introducing Route Line</h1>
              <h4 class="header-subtitle">
                A-first-of-a-kind membership providing access to premium RVs and
                adventure vehicles.
              </h4>
              <h4 class="header-subtitle">
                Opt out of high maintenance ownership and explore the outdoors
                hassle free!
              </h4>
              <h4 class="pb-0">
                MAKE YOUR SUMMER PLANS! IMMEDIATE ACCESS! NO COMMITMENT WITH
                REDUCED INITIATIONS!
              </h4>
              <h2 class="header-title"></h2>
            </div>
          </div>
        </div>
      </header>

      <div class="container">
        <div>
          <div class="cards">
            <div v-for="(n, i) in plans" :key="i" class="col-4">
              <Membership
                :nth="(i + 1) % 2 === 0 ? true : false"
                :data="n"
                :show="true"
              />
            </div>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-sm-12 col-md-4">
            <img src="@/assets/1.png" alt="" class="images" />
          </div>
          <div class="col-sm-12 col-md-4">
            <img src="@/assets/3.jpg" alt="" class="images" />
          </div>
          <div class="col-sm-12 col-md-4">
            <img src="@/assets/2.jpg" alt="" class="images" />
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Nav from "@/components/navs/Navbar.vue";
import axios from "axios";
import Footer from "@/components/navs/Footer.vue";
import Membership from "../components/cards/Membership.vue";
// import _ from "loadsh";
export default {
  data: () => ({
    plans: [],
  }),
  mounted() {
    this.getPlans();
  },
  methods: {
    getPlans() {
      axios
        .get(`https://api-prod-dot-pay-routeline.uc.r.appspot.com/api/v1/plan`)
        // .get(`https://pay-routeline.uc.r.appspot.com/api/v1/plan`)
        .then((res) => {
          // this.plans = res.data;
          let newplan = [];
          res.data.forEach((plan) => {
            const desc = plan.description?.split("~");
            newplan.push({
              name: plan.title,
              title: plan.name,
              price: desc?.[0] || '',
              description: plan.subtitle,
              to: `/customer/create?plan=${plan.id}`,
              group_id: plan.group_id,
              subtitle: desc?.[desc?.length - 1],
              priceTag: desc?.length > 2 ? desc?.[1] || '' : desc?.[0],
            });
          });
        this.plans = newplan;
        });
    },
  },
  components: {
    Nav,
    Footer,
    Membership,
  },
};
</script>

<style lang="scss" scoped>
.cards {
  display: flex;
  justify-content: center;
  column-gap: 50px;
  flex-wrap: wrap;
}
.main {
  background: #b3b3b3;
}
#content {
  position: relative;
}
.bg-map {
  position: absolute;
  left: 0;
  right: 0;
  top: -3rem;
  bottom: -3rem;
  z-index: 0;
}
.high-zindex {
  position: relative;
  z-index: 1;
}
.how-works {
  width: 100%;
  pointer-events: none;
}
.header {
  background: var(--primary-color);
  padding-bottom: 50px;
  padding-top: 30px;

  &-img {
    height: 100%;
  }
  &-image {
    width: 100%;
  }
  &-content {
    color: #fff;
    text-align: center;
  }
  &-subtitle {
    font-size: 18px;
  }
}
.images {
  width: 100%;
}
</style>
<style>
.artibot-wrapper--19YJW {
  display: show;
}
</style>
